import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../../../user/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "../axiosInstance";

interface PostBranchProductParams {
    branch_product_name: string;
    branch_product_image: File | null;
}

export const usePutBranchProduct = (productIdx: number) => {
    const accessToken = useAuthStore.getState().accessToken;
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ branch_product_name, branch_product_image }: PostBranchProductParams) => {
            const formData = new FormData();
            formData.append("branch_product_name", branch_product_name);
            if (branch_product_image) {
                formData.append("branch_product_image", branch_product_image);
            }
            const res = await axiosInstance.put(
                enum_api_uri.put_branch_product_detail.replace(":branch_product_idx", productIdx.toString()),
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                },
            );

            return res.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["getBranchProduct"] });
        },
    });
};
